import { useEffect } from 'react'

import useSessionStore from '@/stores/sessionStore'

const UserSession: React.FC = () => {
	const hasHydrated = useSessionStore((state) => state.hasHydrated)
	const sessionExpires = useSessionStore((state) => state.session?.expires)
	const hydrate = useSessionStore((state) => state.hydrate)
	const resetSession = useSessionStore((state) => state.resetSession)
	const createExpirationHandler = useSessionStore(
		(state) => state.createExpirationHandler
	)

	useEffect(() => {
		hydrate()
		return () => {
			resetSession()
		}
	}, [hydrate, resetSession])

	useEffect(() => {
		if (!sessionExpires) return
		const handler = createExpirationHandler()
		document.addEventListener('click', handler, true)
		return () => document.removeEventListener('click', handler, true)
	}, [sessionExpires, createExpirationHandler])

	if (!hasHydrated) {
		return null
	}
}

export default UserSession
